module.exports = __webpack_public_path__ + "static/img/dynamicd.a38c679.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamicd.png
// module id = tJ1A
// module chunks = 45